import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import { useAppDispatch, useAppSelector } from './store';
import { validateToken } from './store/slices/authSlice';

// 布局组件
import MainLayout from './components/layout/MainLayout';

// 页面组件
import HomePage from './pages/HomePage';
import UpdateHistoryPage from './pages/UpdateHistoryPage';
import UserManagementPage from './pages/UserManagementPage';
import NotFoundPage from './pages/NotFoundPage';

// 需要认证的路由守卫
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAppSelector((state) => state.auth);
  
  if (!user) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

// 管理员路由守卫
const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAppSelector((state) => state.auth);
  
  if (!user || user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    // 验证当前认证状态
    const token = localStorage.getItem('auth_token');
    if (token) {
      dispatch(validateToken())
        .unwrap()
        .then(user => {
          console.log('认证状态验证成功', user);
        })
        .catch(err => {
          console.warn('认证状态验证失败', err);
          // 确保清除token
          localStorage.removeItem('auth_token');
        });
    }
  }, [dispatch]);
  
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            {/* 公开路由 */}
            <Route index element={<HomePage />} />
            
            {/* 受保护路由 */}
            <Route 
              path="update-history" 
              element={
                <ProtectedRoute>
                  <UpdateHistoryPage />
                </ProtectedRoute>
              } 
            />
            
            {/* 管理员路由 */}
            <Route 
              path="users" 
              element={
                <AdminRoute>
                  <UserManagementPage />
                </AdminRoute>
              } 
            />
            
            {/* 404路由 */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App; 